<template>
<AppLayout>
  <div class="inventory">
    <section id="suppliers-add" class="filter-search">
      <div class="container">
          <h6 class="fw-bold">Add Supplier</h6>
          <p class="mt-3 fw-bold">1. Add Details</p>
          <div>
            <div class="form">
              <div class="row">
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="product-name">Supplier Name</label>
                    <input type="text" class="form-control" id="product-name" v-model="name">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="product-name">VAT Number</label>
                    <input type="text" class="form-control" id="product-name" v-model="idNumber">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="item-code">Business Description</label>
                    <input type="text" class="form-control" id="item-code" v-model="natureBusiness">
                  </div>
                </div>
               
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="address">Office Address</label>
                    <input type="text" v-model="address" id="address" class="form-control">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="item-code">Supplier Contact Person</label>
                    <input type="text" class="form-control" id="item-code" v-model="contact">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="item-code">Mobile No.</label>
                    <input type="tel" class="form-control" id="item-code" v-model="phone">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="item-code">Email</label>
                    <input type="email" class="form-control" id="item-code" v-model="email">
                  </div>
                </div>

                <!--
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="product-picture">ID Front</label>
                    <input type="file" class="form-control" id="id-font" ref="idFront" @change="handleIDChange">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="product-picture">ID Back</label>
                      <input type="file" class="form-control" id="id-back" ref="idBack" @change="handleIDChange">
                  </div>
                </div>-->
                
                <div class="col-md-2" v-if="loading">
                  <div style="margin-top: 40px"> 
                    processing ID
                    <img  src="../../assets/images/loader.gif"/> 
                  </div>
                </div>

                <div class="col-md-2">
                    <div class="check-button">
                    <div class="form-group">
                        <label>Pre-qualified</label>
                        <div class="components-button">
                    <span class="switcher switcher-1">
                        <input type="checkbox" id="switcher-1" v-model="qualified">
                        <label for="switcher-1"></label>
                    </span>
                        </div>
                    </div>
                    </div>
                </div>


                 <div class="col-md-2">
                  <div class="form-group">
                    <label for="procurement-categories">Procurement Categories</label>
                    <multiselect v-model="selectedTenderCategoryObjects"
                      :options="tenderCategories"
                      :multiple="true"
                      track-by="id"
                      label="name"
                      placeholder="Select procurement categories"
                      class="form-control"
                    />
                  </div>
                </div>

                
                <div class="col-md-1" style="padding-left: 0px;">
                    <button v-if="supplierId == ''" 
                            class="btn-style small" 
                            style="margin-top: 32px" 
                            @click="postSupplier"
                            :disabled="isPosting">
                        <span v-if="isPosting">
                            Adding
                            <img src="../../assets/images/loader.gif" style="width: 20px; margin-left: 5px"/>
                        </span>
                        <span v-else>Add</span>
                    </button>
                </div>
  
              </div>
  
            </div>
          </div>
          <div :style="{ 'display': displayDocuments }">
            <p class="fw-bold">2. Add Documents</p>
            <table class="table table-hover">
              <thead>
                <th>No.</th>
                <th>Document Name</th>
                <th>Document Type</th>
                <th>Renewal/Expiry Date</th>
                <th>Upload Document</th>
                <th>Action</th>
              </thead>
              <tbody>
                <tr>
                    <td>1</td>
                    <td><input type="text" placeholder="Enter name" class="form-control" v-model="documentName"></td>
                    <td>
                      <select class="form-control" v-model="selectedSupplierDocumentTypeId">
                        <option value="">Select type</option>
                        <option v-for="t in supplierDocumentTypes" :key="t.id" :value="t.id">{{ t.name }}</option>
                      </select>
                    </td>
                    <td><input type="date" placeholder="Choose date" class="form-control" v-model="expiry"></td>
                    <td><input type="file"  class="form-control" ref="fileDocument" @change="handleFileChange"></td>
                    <td><button class="btn btn-default btn-sm pull-right" style="border:1px solid black; margin-top: 10px" @click="postSupplierDocument">Add</button></td>
                </tr>
                <tr v-for="(document, index) in documents" :key="document.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ document.name }}</td>
                  <td>{{ document.supplierDocumentType?.name || '—' }}</td>
                  <td>{{ formatDate(document.expiry) }}</td>
                  <td>
                    <a :href="`${urlServer}/files/${document.document}`" class="btn btn-sm btn-primary">View Document</a>
                  </td>
                  <td>
                    <button class="btn btn-sm btn-danger" @click="deleteSupplierDocument(document.id)">Delete</button>
                  </td>
                </tr>
              </tbody>    
            </table>
              </div>
            </div>
            </section>
      </div>
</AppLayout>
          
  </template>
  
  <script>
  import Swal from 'sweetalert2'
  import AppLayout from '../../components/AppLayout.vue';
  import axios from 'axios'
  import Multiselect from 'vue-multiselect';
  
  export default {
    name: 'AddSupplierPage',
    components: {
      AppLayout,
      Multiselect
    },
    data: () => ({
      token: JSON.parse(localStorage.getItem('access_token')),
      urlServer:process.env.VUE_APP_URL,
      supplierId: "",
      displayDocuments: "none",
      tenderCategories: [],
      selectedTenderCategoryIds: [],
      selectedTenderCategoryObjects: [],
      name: "",
      natureBusiness: "",
      address: "",
      contact: "",
      phone: "+254",
      idNumber: "",
      email: "",
      qualified: true,
      document: "",
      documents: [],
      supplierDocumentTypes: [],
      selectedSupplierDocumentTypeId: '',
      loading: false,
      documentName: "",
      expiry:"", 
      idFront: null,
      idBack: null,
      isPosting: false
    }),
    async created() {
      await this.loadTenderCategories()
      await this.loadSupplierDocumentTypes()
    },
    methods:{
        isValidPhoneNumber(number) {
            const regex = /^\+254\d{9}$/;
            return regex.test(number);
        },
        
        async postSupplier () {
          if(!this.isValidPhoneNumber(this.phone)){
            Swal.fire({
              icon: 'error',
              title: 'Invalid phone number',
              text: 'Expected format +254.... 13 character long'
            })
            return 
          }

          this.isPosting = true;
          try {
            const requestOptions = {
              method: "POST",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
              body: JSON.stringify({ 
                name: this.name,
                business: this.natureBusiness,
                address: this.address,
                idNumber: this.idNumber,
                contact: this.contact,
                phone: this.phone,
                email: this.email,
                prequalified: this.qualified,
                tenderCategoryIds: this.selectedTenderCategoryObjects.map(c => c.id),
              })
            };
            const res = await fetch(process.env.VUE_APP_URL+'/suppliers', requestOptions)
            const data = await res.json()
            if(data.status == true){
                this.supplierId = data.supplier.id
                this.displayDocuments = "block"
                Swal.fire({
                    icon: 'success',
                    title: 'Supplier created successfully',
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Supplier not created',
                    text: data.message
                })
            }
          } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error creating supplier',
                text: error.message || 'An error occurred'
            })
          } finally {
            this.isPosting = false;
          }
        },
       async loadTenderCategories() {
         try {
           const res = await fetch(process.env.VUE_APP_URL + '/tender-category', {
             headers: { 'Accept': 'application/json', 'Authorization': 'Bearer ' + this.token }
           })
           if (!res.ok) return
           const data = await res.json()
           this.tenderCategories = Array.isArray(data) ? data : (data.data || [])
          // If we previously had ids selected, map them to objects for multiselect
          if (this.selectedTenderCategoryIds && this.selectedTenderCategoryIds.length) {
            this.selectedTenderCategoryObjects = this.tenderCategories.filter(cat => this.selectedTenderCategoryIds.includes(cat.id))
          }
         } catch (e) {
           console.error('Failed to load tender categories', e)
         }
       },
      async loadSupplierDocumentTypes() {
        try {
          const res = await fetch(process.env.VUE_APP_URL + '/supplier-document-type', {
            headers: { 'Accept': 'application/json', 'Authorization': 'Bearer ' + this.token }
          })
          if (!res.ok) return
          const data = await res.json()
          this.supplierDocumentTypes = Array.isArray(data) ? data : (data.data || [])
        } catch (e) {
          console.error('Failed to load supplier document types', e)
        }
      },
       async handleIDChange() {
          this.idFront = this.$refs.idFront.files[0];
          this.idBack = this.$refs.idBack.files[0];
          const formaData ={
            front_image: this.idFront,
            back_image: this.idBack
          }
          try{
            this.loading = true
            if(this.idFront !== null &&  this.idBack !== null){
            const response = await axios.post(
              `http://139.162.190.156:8000/kyc/predict?api_key=511629d1-9a0f-4488-aae0-c8a43ae6cb1f`,
              formaData,
              {
                headers: {
                  'Content-Type': `multipart/form-data`,
  
                },
              }

            )
            const data = response.data.result
            this.name = data.fullName
            this.idNumber = data.idNumber
            console.log("KYC",response)
          }
          }catch(err){
            console.log(err)
          }finally{
            this.loading = false
          }
          
        },

        async postSupplierDocument () {
          const formData = new FormData();
          formData.append("name", this.documentName)
          formData.append("idNumber", this.idNumber)
          formData.append("expiry", this.expiry)
          formData.append("supplierId", this.supplierId)
            if (this.selectedSupplierDocumentTypeId) {
              formData.append('supplierDocumentTypeId', this.selectedSupplierDocumentTypeId)
            }
          formData.append("file", this.document)

          axios.post(process.env.VUE_APP_URL+'/suppliers/document', 
            formData, 
            {
              headers:{ 
                "Content-Type": "multipart/form-data", 
                'Authorization': 'Bearer '+this.token 
              }}).then(function(data) {
              if(data.data.status == true){
                  this.documentName = "";
                  this.expiry = "";
                  this.document = "";
                  this.selectedSupplierDocumentTypeId = '';
                  this.documents = data.data.documents
              }else{
                  Swal.fire({
                      icon: 'error',
                      title: 'Supplier Document not created',
                      text: data.data.message
                  })
              }
            }.bind(this))
        },
        formatDate(date) {
          if (!date) return '';
          try {
            return new Date(date).toLocaleDateString();
          } catch (e) {
            return date;
          }
        },
        handleFileChange() {
          this.document = this.$refs.fileDocument.files[0];
        },
        async deleteSupplierDocument (documentid) {
          const requestOptions = {
              method: "GET",
              headers: { 
                'Accept': 'application/json',
                'Authorization': 'Bearer '+this.token 
              },
          };
          const res = await fetch(process.env.VUE_APP_URL+'/suppliers/document/'+documentid, requestOptions)
          const data = await res.json()
          if(data.status == true){
              Swal.fire({
                  icon: 'success',
                  title: 'Supplier Document deleted successfully',
                  text: 'Supplier Document deleted'
              })
              this.documents = data.documents;
          }else{
              Swal.fire({
                  icon: 'error',
                  title: 'Supplier Document not deleted',
                  text: data.message
              })
          }
        },
        
    }
  }
  </script>

  <style lang="scss" scoped>

@import 'vue-multiselect/dist/vue-multiselect.min.css';

$primary: #d2d2d2;
$green: #000000;
$white: #ffffff;
  .check-button{
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .form-group{
        .components-button {
          display: flex;
          align-items: center;
          justify-content: left;
          span.switcher {
            position: relative;
            width: 156px;
            height: 56px;
            border-radius: 10px;
            input {
              appearance: none;
              position: relative;
              width: 130px;
              height: 40px;
              border-radius: 3px;
              border-color: #d2d2d2 !important;
              background: $primary;
              outline: none;
              font-family: 'Oswald', sans-serif;
              &:before, &:after {
                z-index: 2;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                color: $white;
              }
              &:before {
                content: 'Yes';
                left: 14px;
                font-weight: 600;
                font-size: 14px;
                line-height: 33px;
                color: #FFFFFF;
              }
              &:after {
                content: 'No';
                right: 14px;
                font-weight: 600;
                font-size: 17px;
                line-height: 33px;
                color: #FFFFFF;
              }
            }
            label {
              z-index: 1;
              position: absolute;
              width: 55px;
              height: 32px;
              margin: 0;
              top: 4px;
              left: 71px !important;
              border-radius: 3px;
            }
            &.switcher-1, &.switcher-2 {
              input {
                transition: .25s -.1s;
                &:checked {
                  background: $primary;
                  &:before {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  &:after {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  & + label {
                    left: 4px !important;
                    background: $green;
                    transition: left .5s, right .4s .2s;
                    height: 30px !important;
                  }
                }
                &:not(:checked) {
                  background: $primary;
                  transition: background .5s -.1s;
                  &:before {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  &:after {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  & + label {
                    left: 100px;
                    right: 10px;
                    height: 30px !important;
                    background: $green;
                    transition: left .4s .2s, right .5s, background .35s -.1s;
                  }
                }
              }
            }
          }
        }
    }

    .input-file{
      border-radius: 3px!important;
      height: 38px;
      display: flex; 
      align-items: center;
      padding-top: 8px !important;
      padding-left: 4px  !important;
      background: $white!important;
      border: 1px solid #b4c7e7 !important;
      color: black;
      &::placeholder{
        color: black;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        text-transform: capitalize;
      }
      &:focus{
        box-shadow: none;
      }
}

.multiselect__tag {
    background-color: blue !important; 
    color: white; 
    border-radius: 4px;
    padding: 5px 10px;
    margin: 2px;
}
  
.multiselect__tag:hover {
  background-color: #45a049; 
}

.multiselect__tag .multiselect__tag-icon {
  color: white; 
}

/* Increase multiselect width and height for better usability */
.multiselect {
  width: 100% !important;
  min-height: 44px;
  box-sizing: border-box;
}
.multiselect .multiselect__tags {
  min-height: 44px;
  align-items: center;
}
.multiselect .multiselect__input,
.multiselect .multiselect__single {
  height: 40px !important;
  line-height: 40px !important;
}
.multiselect .multiselect__placeholder {
  line-height: 40px;
}
.multiselect .multiselect__select {
  height: 40px;
}





  </style>